import { render, staticRenderFns } from "./MultipleOrders.vue?vue&type=template&id=3f766e6b&"
import script from "./MultipleOrders.vue?vue&type=script&lang=js&"
export * from "./MultipleOrders.vue?vue&type=script&lang=js&"
import style0 from "./MultipleOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports